module.exports = __webpack_public_path__ + "static/img_4467-d8575321ee2a7345f6be2bc59e148e36.webp";